Monitoring.Views ||= {}

class AccountSettings.AcdSettingsByFilterView extends Backbone.View
  template: JST["backbone/templates/account_settings/acd_setting/acd_settings_by_filter"]

  initialize: (@options = {}) ->
    @teamsAndFiltersSettings = @options.teamsAndFiltersSettings

  render: =>
    @subviews = []
    @$el.html(@template(@))
    @initializeTooltips()
    @renderEachTeamsSettings()
    @

  initializeTooltips: ->
    @$el.find('.with-tooltip').tooltip({
      placement: 'bottom'
    })

  renderEachTeamsSettings: ->
    _.each(@teamsAndFiltersSettings, (settings, team)=>
      @renderTeamAndItsSettings(team, settings)
    )

  renderTeamAndItsSettings:(team, settings)=>
    view = new AccountSettings.AcdSettingForFilterView({ team: team, settings: settings })
    @subviews.push(view)
    @$el.find('.acd-settings-for-filters').append(view.render().$el)

  getActivatedTeams: ->
    ret = []
    _.each(@subviews, (subview) =>
      ret.push(subview.teamName) if subview.settings.active
    )
    ret

  getSettingsByFilter: ->
    ret = {}
    _.each(@subviews, (subview) =>
      setting = subview.getSelectedSetting()
      ret[subview.teamName] = setting
    )
    ret
